import React from 'react';
import { fmtDateShort } from '../../utils/dates';
import { PIPELINE, STAGE_AR } from './BookStatus';

// المرحلة التي وصل إليها الملف — الملغى يتوقّف عند مرحلته والمعتمد يكملها كلها
function reachedIndex(status) {
  if (status === 'approved') return PIPELINE.length;
  const i = PIPELINE.indexOf(status);
  return i === -1 ? 0 : i;
}

const STAGE_HOLDER = {
  summarizing: (s) => s.researcher_name,
  under_review: (s) => s.reviewer_name,
  revising: (s) => s.researcher_name,
  awaiting_approval: () => 'المشرف العام',
};

/**
 * شريط مراحل الكتاب مع مهلة المرحلة الجارية ومن يمسك الملف.
 * `compact` للاستخدام داخل صفّ الجدول: نقاط بلا نصوص.
 */
export default function BookStageBar({ summary, compact = false }) {
  const reached = reachedIndex(summary.status);
  const cancelled = summary.status === 'cancelled';

  return (
    <div style={{ display: 'flex', alignItems: compact ? 'center' : 'flex-start', gap: compact ? 4 : 0 }}>
      {PIPELINE.map((stage, i) => {
        const isCurrent = !cancelled && summary.status === stage;
        const isDone = !cancelled && i < reached;
        const cls = isDone ? 'report-icon-done' : isCurrent ? 'report-icon-active' : 'report-icon-todo';
        const holder = STAGE_HOLDER[stage]?.(summary);

        return (
          <React.Fragment key={stage}>
            {i > 0 && (
              <div
                aria-hidden="true"
                style={{
                  flex: compact ? '0 0 10px' : 1,
                  height: 2,
                  marginTop: compact ? 0 : 11,
                  background: isDone || isCurrent ? 'var(--primary)' : 'var(--border)',
                }}
              />
            )}
            <div style={{ textAlign: 'center', flex: compact ? '0 0 auto' : '0 0 auto', minWidth: compact ? 0 : 96 }}>
              <div
                className={`report-icon ${cls}`}
                title={`${STAGE_AR[stage]}${holder ? ` — ${holder}` : ''}`}
                style={{ margin: '0 auto' }}
              >
                {isDone ? '✓' : isCurrent ? '◔' : ''}
              </div>
              {!compact && (
                <>
                  <div style={{ fontSize: 12, marginTop: 6, color: isCurrent ? 'var(--primary)' : 'var(--text-muted)' }}>
                    {STAGE_AR[stage]}
                  </div>
                  {holder && (
                    <div style={{ fontSize: 11, color: 'var(--text-faint)' }}>{holder}</div>
                  )}
                  {isCurrent && summary.stage_due_date && (
                    <div style={{ fontSize: 11, color: summary.is_overdue ? 'var(--danger)' : 'var(--text-faint)' }}>
                      {summary.is_overdue ? 'تأخّر عن ' : 'حتى '}
                      {fmtDateShort(summary.stage_due_date)}
                    </div>
                  )}
                </>
              )}
            </div>
          </React.Fragment>
        );
      })}

      {!compact && cancelled && (
        <div style={{ marginRight: 12, fontSize: 12, color: 'var(--danger)' }}>
          ملغى{summary.cancel_reason ? ` — ${summary.cancel_reason}` : ''}
        </div>
      )}
    </div>
  );
}
